import { Button } from '../ui/Button';
import { useActivityComposer } from './ActivityComposerContext';

// ---------------------------------------------------------------------------
// Icon
// ---------------------------------------------------------------------------

function PlusIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      aria-hidden="true"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
    </svg>
  );
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

/**
 * Primary-variant rectangular button that opens the ActivityWizardForm modal
 * via ActivityComposerContext. Mounted in the sidebar (above the Start timer
 * button), the mobile header, and the activities page header.
 *
 * On narrow mobile widths the label is hidden (icon-only) to fit beside the
 * mobile timer indicator. aria-label keeps the button accessible either way.
 *
 * @param fullWidth - Expand to fill the container width (used in the stacked
 *   sidebar layout).
 * @param size - `sm` for sidebar / mobile header (default), `md` for the
 *   activities page header to match the "New invoice" / "Add client" CTAs
 *   on other pages.
 */
export function LogActivityButton({
  fullWidth = false,
  size = 'sm',
}: {
  fullWidth?: boolean;
  size?: 'sm' | 'md';
}) {
  const { openComposer } = useActivityComposer();
  const iconSize = size === 'md' ? 'h-4 w-4' : 'h-3.5 w-3.5';

  return (
    <Button
      type="button"
      variant="primary"
      size={size}
      onClick={() => openComposer()}
      aria-label="Log activity"
      className={fullWidth ? 'w-full' : undefined}
    >
      <PlusIcon className={`${iconSize} shrink-0`} />
      <span className={fullWidth ? undefined : 'hidden sm:inline'}>Log activity</span>
    </Button>
  );
}
